module.exports = __webpack_public_path__ + "img/sjxmsj.275b41bc.png";